import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { EmailForm } from './EmailForm';
import { Attachments } from './Attachments';
import { useSendPurchaseOrder } from './useSendPurchaseOrder';
import { ADMIN_ROUTES } from 'constants/routes';
import { ArrowLeftIcon } from 'components/common/icons';
import { Button, Card, Typography, Divider, Row, Col, Spin, Image } from 'components';
import styles from './styles.module.scss';

const { Title } = Typography;

export const SendPurchaseOrder: React.FC = memo(() => {
  const {
    purchaseOrderId,
    form,
    contactPersons,
    isPurchaseOrderLoading,
    purchaseOrderDetails,
    attachmentTypes,
    currentUser,
    fileList,
    error,
    attachmentType,
    attachments,
    emailTemplate,
    disabledActions,
    previewImage,
    isPreviewVisible,
    setAttachmentType,
    setFileList,
    setIsPreviewVisible,
    handleContactPersonChange,
    onLanguageChange,
    handleEmailTemplateChange,
    handleAddAttachment,
    handleDeleteAttachment,
    handleFileSizeValidation,
    handleCancelAttachment,
    handleCancel,
    handleSubmit,
    disabledSubmit,
    onSavePurchaseOrderAttachments,
  } = useSendPurchaseOrder();

  return (
    <Spin spinning={isPurchaseOrderLoading} className={styles.container}>
      <div style={{ paddingLeft: 24 }}>
        <Button title="Click to go back" onClick={handleCancel} type="link" icon={<ArrowLeftIcon />} />
      </div>

      <Row gutter={[0, 24]} justify="center">
        <Col span={24}>
          <Title className={styles.general_title} level={2}>
            Send Purchase Order
          </Title>
        </Col>

        <Col span={24} className={styles.form_container}>
          <Card className={styles.section}>
            <Title level={5} className={styles.sectionTitle} underline>
              <Link
                to={`${ADMIN_ROUTES.suppliers.view}/${purchaseOrderDetails?.supplier?.id}/general`}
                target={'_blank'}
              >
                Supplier: {purchaseOrderDetails?.supplier?.name}
              </Link>
            </Title>

            {/* Email Form Section */}
            <EmailForm
              form={form}
              contactPersons={contactPersons}
              currentUser={currentUser}
              emailTemplate={emailTemplate}
              handleContactPersonChange={handleContactPersonChange}
              onLanguageChange={onLanguageChange}
              handleEmailTemplateChange={handleEmailTemplateChange}
              supplierId={purchaseOrderDetails?.supplier?.id}
            />

            {/* Attachments Section */}
            <Attachments
              fileList={fileList}
              error={error}
              attachmentType={attachmentType}
              attachmentTypes={attachmentTypes}
              attachments={attachments as any}
              disabledActions={disabledActions}
              setAttachmentType={setAttachmentType}
              setFileList={setFileList}
              handleAddAttachment={handleAddAttachment}
              handleDeleteAttachment={handleDeleteAttachment}
              handleFileSizeValidation={handleFileSizeValidation}
              handleCancelAttachment={handleCancelAttachment}
              onSelectAttachments={onSavePurchaseOrderAttachments}
              purchaseOrderId={purchaseOrderId || ''}
            />
          </Card>
        </Col>
      </Row>

      <Row style={{ marginTop: 32 }} justify="end">
        <Col offset={1} span={23}>
          <Divider style={{ marginBottom: 32 }} className={styles.divider} />
        </Col>
        <Col flex="328px">
          <Row justify="end" wrap={false} className="gap-8">
            <Button disabled={disabledSubmit} block size="large" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              loading={disabledSubmit}
              disabled={disabledSubmit}
              block
              size="large"
              type="primary"
              onClick={handleSubmit}
            >
              Send
            </Button>
          </Row>
        </Col>
      </Row>

      {/* Image Preview Modal (hidden image trigger) */}
      {previewImage && (
        <Image
          src={previewImage}
          style={{ display: 'none' }}
          preview={{
            visible: isPreviewVisible,
            onVisibleChange: (visible) => setIsPreviewVisible(visible),
          }}
        />
      )}
    </Spin>
  );
});
